import { render, staticRenderFns } from "./ImgViewer.vue?vue&type=template&id=51111abe&scoped=true"
import script from "./ImgViewer.vue?vue&type=script&lang=%20ts"
export * from "./ImgViewer.vue?vue&type=script&lang=%20ts"
import style0 from "./ImgViewer.vue?vue&type=style&index=0&id=51111abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51111abe",
  null
  
)

export default component.exports